import axios from "axios";

/** The API's own message when it has one, e.g. why a 403 was refused. */
export function accountActionErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (!axios.isAxiosError(error)) return fallback;
  const message = (error.response?.data as { message?: unknown } | undefined)
    ?.message;
  return typeof message === "string" ? message : fallback;
}
